export default "__VITE_ASSET__DgTqcxHJ__"